import { useSelector } from 'react-redux';
import { selectUserId } from 'core/userContext';
import { Member } from './types';

export const useIsMfaResetAvailable = (member: Member) => {
  const currentUserId = useSelector(selectUserId);
  const isMemberCurrentUser = member.userId === currentUserId;

  /**
    Restrict the current user from resetting their own MFA
   */
  return member.tfa && !isMemberCurrentUser;
};
